import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { LeadRuleViewModel, TurnItOnForOptions } from '../../../../viewModels/leadrules';
import { styleSheet } from './../../styles';
import { DailyActivityTeam } from './DailyActivityTeam';
import { Everyone } from './Everyone';
import { Individual } from './Individual';
import { Vertical } from './Vertical';

interface IProps {
	leadRule: LeadRuleViewModel;
	onSelect: (option: TurnItOnForOptions) => void;
}

export const TurnItOnFor: React.FC<IProps> = observer(({ leadRule, onSelect }) => {
	const [radio, setRadio] = useState<TurnItOnForOptions>(leadRule?.currentType);

	const handleRadio = (state: TurnItOnForOptions) => () => {
		onSelect(state);
		setRadio(state);
	};

	useEffect(() => {
		if (leadRule) {
			handleRadio(leadRule?.currentType)();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [leadRule]);

	return (
		<div className={css(styleSheet.radioContainer)}>
			<div className={css(styleSheet.subtitle)}>Turn it on for:</div>

			<Everyone
				enabled={radio === TurnItOnForOptions.Everyone}
				onChangeToEnable={handleRadio(TurnItOnForOptions.Everyone)}
			/>

			<Vertical
				enabled={radio === TurnItOnForOptions.Vertical}
				leadRule={leadRule}
				onChangeToEnable={handleRadio(TurnItOnForOptions.Vertical)}
			/>

			{leadRule?.userSession?.account?.isLevitateSalesCoffeeAccount && (
				<DailyActivityTeam
					enabled={radio === TurnItOnForOptions.DailyActivityTeam}
					leadRule={leadRule}
					onChangeToEnable={handleRadio(TurnItOnForOptions.DailyActivityTeam)}
				/>
			)}

			<Individual
				enabled={radio === TurnItOnForOptions.Individual}
				leadRule={leadRule}
				onChangeToEnable={handleRadio(TurnItOnForOptions.Individual)}
			/>
		</div>
	);
});
